import { Box, Button, Card, Checkbox, FormControl, FormLabel, Input, Table, Typography } from '@mui/joy';
import React, { useEffect, useState } from 'react'
import { haspermission } from '../../../Script/Permission';
import { post, Token } from '../../../Script/Session';
import { useNavigate } from 'react-router-dom';


function OverviewPoints() {
    const [data, setdata] = useState();
    const [perm, setperm] = useState(haspermission("29"));
    const [create, setcreate] = useState(false);
    const [nameinput, setnameinput] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body, "/punktekonto");
        setdata(JSON.parse(response)?.result);
    }, []);
    const [groupdata, setgroupdata] = useState();
    useEffect(() => {
        const fetchData = async () => {

            try {
                const body = {
                    token: Token.get(),
                    action: "get",
                };

                const response = await post(body, "/editGroups");

                if (!response) {
                    alert("hat einen Fehler!");
                    return;
                }

                const json = JSON.parse(response);
                setgroupdata(json);
                console.log(response);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        // Delay fetch slightly to avoid blocking render

        fetchData();

    }, [])
    function update() {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body, "/punktekonto");
        setdata(JSON.parse(response)?.result);
    }
    function createkath() {
        if (nameinput == "") {
            return;
        }
        let body = {};
        body.token = Token.get();
        body.action = "create";
        body.name = nameinput;
        let response = post(body, "/punktekonto");
        update();
        setnameinput("");
        setcreate(false);
    }
    function del(a) {
        let body = {};
        body.token = Token.get();
        body.action = "delete";
        body.name = a;
        let response = post(body, "/punktekonto");
        update();

    }
    const [oldname, setoldname] = useState();
    const [createsubkath, setcreatesubkath] = useState(false);
    const [kathtoadd, setkathtoadd] = useState("");
    const [proportional, setproportional] = useState(false);
    const [variablepunkte, setvariablepunkte] = useState(false);
    const [points, setpoints] = useState(0);
    const [bis, setbis] = useState(0);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // use 'auto' for instant scroll
        });
    };
    function addsubkath() {
        let body = {};
        body.token = Token.get();
        body.action = "add_subkath";
        body.kathname = kathtoadd;
        body.name = nameinput;
        body.variable = variablepunkte;
        body.prop = proportional;
        body.points = Number(points);
        body.bis = Number(bis);
        let response = post(body, "/punktekonto");
        update();
        setnameinput("");
        setcreatesubkath(false);
        setkathtoadd(null);
        setproportional(false);
        setvariablepunkte(false);
        setpoints(0);
        setbis(0);
    }
    function delsubkath(overkath, name) {
        let body = {};
        body.token = Token.get();
        body.action = "del_subkath";
        body.name = name;
        body.kathname = overkath;
        let response = post(body, "/punktekonto");
        update();
    }
    const [up, setupdate] = useState(false);
    function edit(overname, item) {
        setnameinput(item.name);
        setkathtoadd(overname);
        setoldname(item.name);
        setproportional(item.proportional);
        setvariablepunkte(item.variable);
        setpoints(item.points);
        setbis(item.bis);
        setupdate(true);
    }
    function updatesave() {
        let body = {};
        body.kathname = kathtoadd;
        body.name = nameinput;
        body.variable = variablepunkte;
        body.prop = proportional;
        body.points = Number(points);
        body.bis = Number(bis);
        body.oldname = oldname;
        body.action = "update";
        body.token = Token.get();
        let response = post(body, "/punktekonto");
        update();
        setnameinput("");
        setcreatesubkath(false);
        setkathtoadd(null);
        setproportional(false);
        setvariablepunkte(false);
        setpoints(0);
        setbis(0);
        setupdate(false);
    }
    return (
        <>
            {
                up && (
                    <Card sx={{ mt: 2, mb: 2 }}>
                        <Typography level="title-md">Eintrag bearbeiten</Typography>
                        <Typography mt={-1}>Bearbeiten sie einen Eintrag</Typography>
                        <Input sx={{ width: "20%" }} value={nameinput} onChange={(e) => setnameinput(e.target.value)} placeholder='Kathegoriename' />
                        <Checkbox label="Proportional" checked={proportional} onChange={(e) => setproportional(e.target.checked)} />
                        <Checkbox label="Variable Punktzahl" checked={variablepunkte} onChange={(e) => setvariablepunkte(e.target.checked)} />
                        {
                            variablepunkte ? (
                                <FormControl>
                                    <FormLabel>Punktzahl von</FormLabel>
                                    <Input value={points} onChange={(e) => setpoints(e.target.value)} sx={{ width: "15%" }} placeholder='Punkzahl von' type='number' />
                                    <FormLabel>Punktzahl bis</FormLabel>
                                    <Input value={bis} onChange={(e) => setbis(e.target.value)} sx={{ width: "15%" }} placeholder='Punkzahl bis' type='number' />
                                </FormControl>
                            ) : (
                                <FormControl>
                                    <FormLabel>
                                        Punktzahl
                                    </FormLabel>
                                    <Input value={points} onChange={(e) => setpoints(e.target.value)} sx={{ width: "15%" }} placeholder='Punktzahl' />
                                </FormControl>
                            )


                        }
                        <Button onClick={() => updatesave()} sx={{ width: "10%" }}>
                            Speichern
                        </Button>
                    </Card>
                )
            }
            {
                createsubkath && (
                    <Card sx={{ mt: 2, mb: 2 }}>
                        <Typography level="title-md">Eintrag erstellen</Typography>
                        <Typography mt={-1}>Erstellen sie hier einen neuen Eintrag</Typography>
                        <Input sx={{ width: "20%" }} value={nameinput} onChange={(e) => setnameinput(e.target.value)} placeholder='Kathegoriename' />
                        <Checkbox label="Proportional" value={proportional} onChange={(e) => setproportional(e.target.checked)} />
                        <Checkbox label="Variable Punktzahl" value={variablepunkte} onChange={(e) => setvariablepunkte(e.target.checked)} />
                        {
                            variablepunkte ? (
                                <FormControl>
                                    <FormLabel>Punktzahl von</FormLabel>
                                    <Input value={points} onChange={(e) => setpoints(e.target.value)} sx={{ width: "15%" }} placeholder='Punkzahl von' type='number' />
                                    <FormLabel>Punktzahl bis</FormLabel>
                                    <Input value={bis} onChange={(e) => setbis(e.target.value)} sx={{ width: "15%" }} placeholder='Punkzahl bis' type='number' />
                                </FormControl>
                            ) : (
                                <FormControl>
                                    <FormLabel>
                                        Punktzahl
                                    </FormLabel>
                                    <Input value={points} onChange={(e) => setpoints(e.target.value)} sx={{ width: "15%" }} placeholder='Punktzahl' />
                                </FormControl>
                            )


                        }
                        <Button onClick={() => addsubkath()} sx={{ width: "10%" }}>
                            Speichern
                        </Button>
                    </Card>
                )
            }
            {
                create && (
                    <Card sx={{ mt: 2, mb: 2 }} variant='soft'>
                        <Typography level="title-md">Kathegorie erstellen</Typography>
                        <Typography mt={-1}>Erstellen sie hier eine neue Kathegorie</Typography>
                        <Input sx={{ width: "20%" }} value={nameinput} onChange={(e) => setnameinput(e.target.value)} placeholder='Kathegoriename' />
                        <Button onClick={() => createkath()} sx={{ width: "10%" }}>Speichern</Button>
                    </Card>
                )
            }

            <Card variant='soft'>
                <Typography level="title-md">Kathegorieübersicht</Typography>
                <Typography mt={-1}>Hier ist aufgelistet </Typography>
                <Table>
                    <thead>
                        <tr>
                            <th>Kathegorien</th>
                            <th>Proportional</th>
                            <th>Variable Punkzahl</th>
                            <th>Punktzahl (im Jahr)</th>
                            {
                                perm && (
                                    <th>Bearbeiten</th>
                                )
                            }
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><Typography level="title-md" fontWeight="bold">Funktionen</Typography></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            {
                                perm && (
                                    <td></td>
                                )
                            }
                        </tr>
                        {
                            groupdata && groupdata.values.map((item) => {
                                return (
                                    <tr>
                                        <td>{item.name}</td>
                                        <td>/</td>
                                        <td>Nein</td>
                                        <td>{item.punkte}</td>
                                        {
                                            perm && (
                                                <td></td>
                                            )
                                        }
                                    </tr>
                                )



                            })
                        }


                        {
                            data && data.map((item) => {
                                return (
                                    <React.Fragment>
                                        <tr>
                                            <td><Typography level="title-md" fontWeight="bold">{item.name}</Typography></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            {
                                                perm && (
                                                    <td>
                                                        <Button onClick={() => del(item.name)} color='danger'>Löschen</Button>
                                                        <Button onClick={() => { setcreatesubkath(true); setkathtoadd(item.name); scrollToTop(); }} sx={{ ml: 1 }}>Eintrag Hinzufügen</Button>
                                                    </td>
                                                )
                                            }
                                        </tr>
                                        {
                                            item.subkath.map((itemb) => {
                                                return (
                                                    <tr>
                                                        <td>{itemb.name}</td>
                                                        <td>{itemb.proportional ? "Ja" : "Nein"}</td>
                                                        <td>{itemb.variable ? "Ja" : "Nein"}</td>
                                                        <td>{itemb.variable ? itemb.points + " bis " + itemb.bis : itemb.points}</td>
                                                        {
                                                            perm && (
                                                                <td>
                                                                    <Button onClick={() => delsubkath(item.name, itemb.name)} sx={{ mr: 1 }} color='danger'>Löschen</Button>
                                                                    <Button onClick={() => edit(item.name, itemb)}>Bearbeiten</Button>
                                                                </td>
                                                            )
                                                        }
                                                    </tr>
                                                )
                                            })
                                        }


                                    </React.Fragment>


                                )






                            })
                        }





                    </tbody>
                </Table>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Button onClick={() => setcreate(true)} sx={{ width: "10%" }}>
                        Kathegorie erstellen
                    </Button>
                    <Button sx={{ ml: 2, width: "10%" }} onClick={() => {
                        navigate("/page-history/punktekonto")
                    }}>Historie</Button>
                </Box>

            </Card>
        </>
    )
}

export default OverviewPoints
